const KEY = "demo_session";

export function loadSession() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveSession(session) {
  localStorage.setItem(KEY, JSON.stringify(session));
}

export function clearSession() {
  localStorage.removeItem(KEY);
}

export function isAuthed() {
  return !!loadSession()?.accessToken;
}

export function getAccessToken() {
  return loadSession()?.accessToken || "";
}
